import React, { FC } from 'react';
import { Container, Form } from 'react-bootstrap';
import styles from './ReportingDetailsIndicatorsAddForm.module.css';
import { Button, RadioButton } from '../../atoms';
import { IndicatorResponseDto } from '../../../store/landscapeAPI/indicator/dto/response/indicator-response.dto';

interface ReportingDetailsIndicatorsAddFormProps {
  data: IndicatorResponseDto;
  handleIndicator: (indicator: IndicatorResponseDto) => void;
  handleOnChange: (indicator: IndicatorResponseDto) => void;
}

const ReportingDetailsIndicatorsAddForm: FC<
  ReportingDetailsIndicatorsAddFormProps
> = ({ data, handleIndicator, handleOnChange }) => {
  const handleSubmit: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    handleIndicator(data);
  };

  return (
    <>
      <Container className={styles.form}>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              value={data.name}
              onChange={(e) =>
                handleOnChange({
                  ...data,
                  name: e.target.value,
                })
              }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Indicator Metric</Form.Label>
            <Form.Control
              type="text"
              value={data.unit ?? ''}
              onChange={(e) =>
                handleOnChange({
                  ...data,
                  unit: e.target.value,
                })
              }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Metric type code</Form.Label>
            <Form.Control
              type="text"
              value={data.metricType ?? ''}
              onChange={(e) =>
                handleOnChange({
                  ...data,
                  metricType: e.target.value,
                })
              }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Is Published</Form.Label>
            <br />
            <RadioButton
              defaultChecked={data.published}
              onChange={(checked) =>
                handleOnChange({
                  ...data,
                  published: checked,
                })
              }
            />
          </Form.Group>

          <Button variant={'dark'} onClick={handleSubmit}>
            Save
          </Button>
        </Form>
      </Container>
    </>
  );
};

export default ReportingDetailsIndicatorsAddForm;
